import {
  ADD_PROMO_TO_USER,
  ATTACH_INSTACHAMP_PROMO,
  CONNECT_PROMO,
  DISCONNECT_PROMO,
  PROMOTIONS_LIST,
} from '@mm/api-routes';
import PromotionModel from '../model/PromotionModel';
import AuthenticatedController from './AuthenticatedController';

export default class PromotionController extends AuthenticatedController {
  static attachInstachampPromo(
    companyId: number,
    facebookPageId: number,
    promoCode: string,
  ) {
    return super.post(ATTACH_INSTACHAMP_PROMO(companyId), {
      promoCode,
      facebookPageId,
    });
  }

  static addPromoToUser(companyId: number, promoCode: string) {
    return super.post(ADD_PROMO_TO_USER(companyId), { promoCode });
  }

  static connect(id: number, companyId: number, facebookPageId: number) {
    const params = { company_id: companyId, facebook_page_id: facebookPageId };
    return super.post(CONNECT_PROMO(id), params);
  }

  static disconnect(id: number, companyId: number, facebookPageId: number) {
    const params = { company_id: companyId, facebook_page_id: facebookPageId };
    return super.post(DISCONNECT_PROMO(id), params);
  }

  static async getPromotions(companyId: number) {
    const response = await super.get(PROMOTIONS_LIST(companyId));
    return response as PromotionModel[];
  }
}
